import{jsx as o}from"react/jsx-runtime";import{useCallback as t}from"react";import{styled as r}from"styled-components";import{calcViewAreaHeight as e}from"../services/calcSize.mjs";import{useSize as i}from"../hooks/useSize.mjs";import{VIEW_AREA as m}from"../constants/ElementId.mjs";const s=r.div`
  overflow-x: hidden;
  overflow-y: auto;
  padding: 12px 6px 6px;

  .buttons + * {
    clear: both;
  }
`;function n({style:r,children:n}){const c=t((o=>o(`${e()}px`)),[]),p=i("85vh",c);return o(s,{id:m,style:{...r,height:p},children:n})}export{n as ViewArea};
